import {enableProdMode} from "@angular/core";
import {HTTP_PROVIDERS} from "@angular/http";
import {bootstrap} from "@angular/platform-browser-dynamic";
import {AppComponent} from "./app/app.component";
import {APP_ROUTER_PROVIDERS} from "./app/app.routes";
import {disableDeprecatedForms, provideForms} from "@angular/forms";

if (process.env.ENV === 'production') {
    enableProdMode();
}

bootstrap(AppComponent, [
    APP_ROUTER_PROVIDERS,
    HTTP_PROVIDERS,
    disableDeprecatedForms(),
    provideForms()
]);


/** WEBPACK FOOTER **
 ** ./src/main.ts
 **/